import { create } from "apisauce";
import { API_BASE_URL } from "../config";

export const api = create({ 
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    authorization:
      `Bearer ${window.localStorage.getItem('MI_ID_TOKEN')}`,
  },
});
